import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const STYLE_TAG_ID = 'custom-fonts-styles';

/**
 * Hook que carga la lista combinada de fuentes (Google + personalizadas).
 * Inyecta automáticamente las reglas @font-face de las personalizadas
 * en el <head> para que estén disponibles globalmente.
 *
 * Devuelve { fonts, googleFonts, customFonts, loading, refresh }.
 *
 * `fonts` = ['Playfair Display', 'Mi Fuente', ...] ordenadas
 * para usar directamente en selectores y previews.
 */
const useFonts = () => {
  const [data, setData] = useState({ google_fonts: [], custom_fonts: [] });
  const [loading, setLoading] = useState(true);

  const fetchFonts = async () => {
    try {
      const res = await fetch(`${API_URL}/api/fonts/list`);
      if (res.ok) {
        const d = await res.json();
        setData(d);
        injectCustomFontFaces(d.custom_fonts || []);
      }
    } catch (e) {
      console.error('useFonts:', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFonts();
  }, []);

  const allFonts = [
    ...(data.custom_fonts || []).map((f) => f.name),
    ...(data.google_fonts || []),
  ];

  return {
    fonts: allFonts,
    googleFonts: data.google_fonts || [],
    customFonts: data.custom_fonts || [],
    loading,
    refresh: fetchFonts,
  };
};

const injectCustomFontFaces = (customFonts) => {
  let tag = document.getElementById(STYLE_TAG_ID);
  if (!tag) {
    tag = document.createElement('style');
    tag.id = STYLE_TAG_ID;
    document.head.appendChild(tag);
  }
  const css = (customFonts || [])
    .map((f) => {
      const url = f.url?.startsWith('http') ? f.url : `${API_URL}${f.url}`;
      return `@font-face { font-family: ${JSON.stringify(f.name)}; src: url(${JSON.stringify(url)}) format(${JSON.stringify(f.format || 'truetype')}); font-display: swap; }`;
    })
    .join('\n');
  tag.textContent = css;
};

export default useFonts;
